module.exports = __webpack_public_path__ + "static/Falabella_postvirtual-1d4b5630056d96de33fc2fe8f1c4a68d.png";